<template>
  <aha-profanity-filter
    :text="text"
    :filtering-profanity="!!$store.state.presentation.filteringProfanity"
  />
</template>

<script>
import AhaProfanityFilter from '@mindthegapstudio/stpancras-storybook-app/src/utils/profanity-filter/ProfanityFilter.vue'

export default {
  components: {
    AhaProfanityFilter,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
}
</script>
